import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Row, Col } from 'react-flexbox-grid';
import {
  refundPaymentActions,
} from '../ducks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import rules from '../../../common/rules/rules';
import message from 'antd/lib/message';

const { Item } = Form;

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      refundPayment: refundPaymentActions.request,
    },
    dispatch
  ),
});

@translate()
@Form.create()
@connect(undefined,mapDispatchToProps)
export default class PaymentDivisionModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    payment: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };


  handleSubmit = () => {
    const { payment, actions, form, t } = this.props;
    const paymentId = payment.id
    form.validateFields((err, values) => {
      if (!err) {
        
        this.props.actions.refundPayment( {paymentId, values} )
      }
    });
    this.props.onClose();
  }

  render() {
    const { payment, t, form } = this.props;

    const { getFieldDecorator, getFieldValue } = form;

    if (!this.props.show) {
      return null;
    }

    return <Modal
    visible
    title={
      t('Refundácia platby')
    }
    onCancel={this.onClose}
    footer={[
        <Button type="primary" onClick={this.handleSubmit}>
          {t('Potvrdiť')}
        </Button> ,
        <Button key="cancel" onClick={this.onClose}>
          {t('Zavrieť')}
        </Button> 
    ]}
    >
    <div>
      <Form>
        <Item label={t('IBAN klienta')} >
          {getFieldDecorator('iban', { initialValue: payment.ibanFrom, rules: rules.required })(
            <Input size="default"  value={payment.ibanFrom} />
          )}
        </Item>
        <Item label={t('Variabilný symbol')}>
          {getFieldDecorator('variableSymbol', { initialValue: payment.variableSymbol, rules: rules.required })(
            <Input size="default"  value={payment.variableSymbol}/>
          )}
        </Item>
      </Form>
    </div>
    </Modal>
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/RefundationModal.js